import Vue from 'vue';
import i18n from '@/plugins/i18n';

export default {
  namespaced: true,
  state: {
    currentMonitoringPatientId: null,
    currentMonitoringStartedAt: null,
  },
  mutations: {
    SET_MONITORING_PATIENT: (state, patientId) => {
      state.currentMonitoringPatientId = patientId;
    },
    SET_MONITORING_START_TIME: (state, startedAtTimestamp) => {
      state.currentMonitoringStartedAt = startedAtTimestamp;
    },
  },
  actions: {
    startMonitoring: ({ commit }, patientId) => {
      Vue.prototype.$api.rpmHistory.startTimeTracking({ patientId })
        .then(({ data }) => {
          commit('SET_MONITORING_PATIENT', patientId);
          commit('SET_MONITORING_START_TIME', +new Date(data.payload.createdAt));

          Vue.prototype.$notifySuccess(i18n.t('notifications.timerStarted'));
        })
        .catch(err => Vue.prototype.$errorMessageHandler(err));
    },
    stopMonitoring: ({ commit, state }, patientId = null) => {
      console.log('ololololö;');
      const id = patientId || state.currentMonitoringPatientId;
      Vue.prototype.$api.rpmHistory.stopTimeTracking({ patientId: id }).then(() => {
        commit('SET_MONITORING_PATIENT', null);
        commit('SET_MONITORING_START_TIME', null);

        Vue.prototype.$notifySuccess(i18n.t('notifications.timerStopped'));
      }).catch(err => Vue.prototype.$errorMessageHandler(err));
    },
  },
};
